export const root = '/forecasts'